import React, { useEffect, useState, Fragment } from 'react';
import { Box, Button, TextField } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { Category } from 'models/organization';
import { useTranslation } from 'react-i18next';
import DHDialog from 'components/shared/dh-dialog/dh-dialog.component';

type AddMainCategoryDialogProps = {
    open: boolean;
    onClose: () => void;
    onSave: (category: Category) => void;
    onDelete: (categoryId?: string) => void;
    category?: Category;
};

const AddMainCategoryDialog: React.FC<AddMainCategoryDialogProps> = ({ open, onClose, onSave, onDelete, category }) => {
    const { t: translate } = useTranslation(['manage-actions', 'common']);
    const [name, setName] = useState('');
    const [instructions, setInstructions] = useState('');

    useEffect(() => {
        setName(category?.name || '');
        setInstructions(category?.instructions || '');
    }, [category]);

    const handleSave = () => {
        const categoryObj = { ...category, name, instructions };
        onSave(categoryObj as Category);
        onClose();
    };

    const handleDelete = () => {
        onDelete(category?._id);
        onClose();
    };

    return (
        <DHDialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            title={
                category?._id
                    ? translate('manage-actions:EDIT_MAIN_CATEGORY')
                    : translate('manage-actions:ADD_MAIN_CATEGORY')
            }
            actions={
                <Fragment>
                    {category?._id && (
                        <Box mr={1}>
                            <Button onClick={handleDelete} color="error" startIcon={<DeleteIcon />}>
                                {translate('common:DELETE')}
                            </Button>
                        </Box>
                    )}
                    <Button disabled={!name} onClick={handleSave} color="primary" variant="contained">
                        {translate('common:SAVE')}
                    </Button>
                </Fragment>
            }
        >
            <TextField
                autoFocus
                margin="dense"
                label={translate('manage-actions:CATEGORY_NAME')}
                type="text"
                fullWidth
                value={name}
                onChange={(e) => setName(e.target.value)}
            />
            <TextField
                margin="dense"
                label={translate('manage-actions:INSTRUCTIONS')}
                type="text"
                fullWidth
                multiline
                rows={4}
                value={instructions}
                onChange={(e) => setInstructions(e.target.value)}
            />
        </DHDialog>
    );
};
export default AddMainCategoryDialog;
